<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: jinzb
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
  <div class="content">
    <div class="block">
      <span
        :class="(temp && temp.resourceStatus && temp.resourceStatus == 1) ? 'resource-title block_click' : 'resource-title block_no_click'"
        @click="changeActiveComponents('resourceStatus')">
        <!-- <i class="el-icon-minus title_icon"></i> -->
        <span style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>资源状况
      </span>
      <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">

        <div style="height: 100%">
          <div style="
              margin: 0 5%;
              height: 14%;
              font-size: 1vw;
              color: #fff;
              position: relative;
              top: 0px;
              left: 0px;
            ">
            <div style="
                height: 100%;
                position: absolute;
                top: 2%;
                left: 5%;
                width: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
              ">
              <div>
                草地面积：&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #00fefd; font-size: 1.2vw; padding-left: 5%">{{
          areaAndType.grasslandArea }} 万亩</span>
              </div>
              <div>
                草地类型：&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #00fefd; font-size: 1.2vw; padding-left: 5%">{{
          areaAndType.rangeland }} 类 {{ areaAndType.grasslandType }} 型</span>
              </div>
            </div>
          </div>

          <div style="margin: 0 5%; height: 40%;">

            <v-chart id="rangelandChart" :option="rangelandChart" autoresize style="width:100%;height:100%" />
          </div>
          <div style="margin: 0 5%; height: 46%;">
            <div style="height: 10%;font-size: 1vw; color: #fff; margin: 0 5%;">
              草原级
            </div>
            <v-chart :option="grasslandClassChart" autoresize style="width:100%;height:90%" />
          </div>
        </div>
      </dv-border-box-1>
    </div>
    <div class="block">

      <div style="height: 55%; width: 100%; border-radius: 10px" class="map_image">
        <el-carousel :interval="6000" arrow="always" style="height: 100%">
          <el-carousel-item v-for="item in mapImages" style="height: 100%">
            <div class="image_title">
              <!-- <div>{{ item.name }}</div> -->
            </div>
            <!-- <div style="position: absolute;top: 0;left: 0;">{{ 'wwwwwwwwwww' }}</div> -->
            <div style="width: 100%; height: 90%;position: relative;background-color1: #00fefd;">

              <el-image class="imageBox5" :preview-src-list="mapImages.map(ele =>  ele.url)"
                :src=" item.url" fit="contain" style="width: 100%; height: 100%;object-fit1:cover;">

              </el-image>

              <div style="position: absolute;top: -9%;left:  40%;" class="image_title"> {{ item.name }} </div>



            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="height: 45%; width: 100%">
        <span
          :class="(temp && temp.biologicalStatus && temp.biologicalStatus == 1) ? 'resource-title block_click' : 'resource-title block_no_click'"
          @click="changeActiveComponents('pestStatus')">
          <!-- <i class="el-icon-minus title_icon"></i> -->
          <span
            style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 2%;">▎</span>草原有害生物状况</span>
        <dv-border-box-1 style="height: calc(100% - 40px);" backgroundColor="rgba(14, 45, 40,0.5)">
          <!-- <centerLeft1 /> -->
          <div class="pest_image" style="height: 100%; width: 100%; border-radius: 10px;">
            <div style="height: 4%; width: 100%;"> </div>
            <div style="height: 6%; width: 100%;">
              <div style="height: 100%; width: 94%;margin-left: 3%;">
                <span style=" font-size: 1vw; color: #fff">常见有害生物照片</span>
                <!-- <span style="font-size: 1vw; float: right; color: #13e8e6">常见有害鼠 {{ fileList.length }} 种、虫害
                  {{ fileList1.length }} 种、毒害草 {{ fileList2.length }} 种</span> -->
                  <span style="font-size: 1vw; float: right; color: #13e8e6">{{ pestText }}</span>
                  
              </div>

            </div>
            <div style="height: 4%; width: 100%;"> </div>
            <!-- <div style="height: 10%; width: 100%; display: flex;align-items: center;">
              <span style="margin-left: 3%; font-size: 0.8vw; color: #fff">常见有害生物照片</span>
              <span style="font-size: 1vw; margin-left: 30%; color: #13e8e6">常见有害鼠 {{ fileList.length }} 种、虫害
                {{ fileList1.length }} 种、毒害草 {{ fileList2.length }} 种</span>
            </div> -->
            <div style="height: 38%; width: 100%;  display: flex;">

              <div style="height: 100%;width: 75%;margin-left: 2.5%;">
                <!-- <div style="height: 80%; width: 100%; display: flex;justify-content: space-between;" class="image_box">
                  <div v-for="item in fileList" style="margin-right: 5%;height: 100%;width: 33%;">
                    <el-image style="height: 80%;  " :src="urlprefix + item.url" />
                    <div style="height: 20%;  text-align: center;font-size: 0.8vw; color: #fff">{{ item.name }}</div>
                  </div>
                </div> -->
                <shuhaiCarousel :imageData="fileList" style="height: 100%;width:97%;"></shuhaiCarousel>
                <!-- <div style="height: 20%;text-align: center;font-size: 0.9vw;  color: #13e8e6;font-weight: 600;">鼠害</div> -->
              </div>

              <div style="height: 100%;width: 20%;display: flex;justify-content: center;">
                <div style="height: 100%;width: 92%;">
                  <chonghaiCarousel :imageData="fileList1" style="height: 100%;width: 100%;"></chonghaiCarousel>

                  <!-- <el-carousel :interval="5000" arrow="always" style="height: 80%">
                    <el-carousel-item v-for="item in fileList1" style="height: 100%">
                      <el-image :src="urlprefix + item.url" fit="fit" style="width: 100%; height: 80%"></el-image>
                      <div style="height: 20%;  text-align: center;font-size: 0.8vw; color: #fff">{{ item.name }}</div>
                    </el-carousel-item>
                  </el-carousel> -->



                  <!-- <div style="height: 20%;text-align: center;font-size:0.9vw;  color: #13e8e6;font-weight: 600;">虫害</div> -->
                </div>



              </div>
              <!-- <div style="margin-right:  13px;border: 1px solid red"></div> -->

            </div>
            <div style="height: 3%; width: 100%; "></div>
            <div style="height: 38%; width: 100%; ">
              <div style="height: 100%;width: 100%;">
                <!-- <div style="height: 80%; width: 100%; " class="image_box1">
                  <div v-for="item in fileList2" style="margin-right: 2%;height: 100%;width: 17%; display: inline-block;">
                    <el-image style="width: 100%;height: 80%;  " :src="urlprefix + item.url" />
                    <div style="height: 20%;  text-align: center;font-size: 0.8vw; color: #fff">{{ item.name }}</div>
                  </div>
                </div> -->
                <div style="height: 100%;width: 100%;">
                  <duhaicaoCarousel :imageData="fileList2" style="height: 100%;width: 95%;"></duhaicaoCarousel>
                </div>

                <!-- <div style="height: 20%;text-align: center;font-size: 0.9vw;  color: #13e8e6;font-weight: 600;">毒害草</div> -->
              </div>
            </div>
          </div>
        </dv-border-box-1>
      </div>
      <!-- <dv-border-box-12 style="height: 45%;">
                        <div style=" padding: 16px;height: 100%;width: 100%;border-radius: 10px;">
                        </div>
                    </dv-border-box-12> -->
      <!-- <div style="border: 1px #00ffff solid; height: 45%;width: 100%;border-radius: 10px;">
                        image
                    </div> -->
    </div>
    <div class="block">
      <span
        :class="(temp && temp.ecologicalStatus && temp.ecologicalStatus == 1) ? 'resource-title block_click' : 'resource-title block_no_click'"
        @click="changeActiveComponents('ecologicalCondition')">
        <!-- <i class="el-icon-minus title_icon"></i> -->
        <span style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>生态状况</span>
      <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">

        <div style="margin: 0 5%; height: 100%">
          <div style="height: 50%">
            <div style="display: flex;align-items: center; height: 20%;
                font-size: 1vw;
                color: #fff;
                ">

              <div style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                  
                ">
                <div style="height: 100%;padding-left: 5%">
                  退化草原（轻度、中度和重度）面积<span style="color: #00fefd; font-size: 1vw;">&nbsp;&nbsp; {{ degradationArea
                    }}万亩</span>
                </div>

              </div>
            </div>
            <div style="height: 80%">
              <v-chart :option="degradationChart" autoresize style="width:100%;height:100%" />
            </div>
          </div>
          <div style="height: 50%;">
            <div style="
                height: 14%;
                font-size: 1vw;
                color: #fff;
                position: relative;
                top: 0px;
                left: 0px;">
              <div style="
                  height: 100%;
                  position: absolute;
                  top: 50%;
                  left: 5%;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;">
                <div style="height: 100%">
                  综合植被盖度&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #00fefd; font-size: 1vw; padding-left: 5%">{{
          avgCoverage }}%</span>
                </div>
              </div>
            </div>
            <div style="height: 86%">
              <!-- <Chart :cdata="vegetationCoverageChart" /> -->
              <v-chart :option="vegetationCoverageChart" autoresize style="width:100%;height:100%" />
            </div>
          </div>
        </div>
      </dv-border-box-1>
    </div>



  </div>
</template>
<script>
import leftTop from "../comp/shouye/leftTop.vue";
import leftBottom from "../comp/shouye/leftBottom.vue";
import rightBottom from "../comp/shouye/rightBottom.vue";
import rightTop from "../comp/shouye/rightTop.vue";

import PieChart from "../echarts/pie.vue";

import * as api from "@/api/cloud-screen";
import CFG from "@/config/config";

import shuhaiCarousel from "../carousel/shuhai-carousel.vue";
import chonghaiCarousel from "../carousel/chonghai-carousel.vue";
import duhaicaoCarousel from "../carousel/duhaicao-carousel.vue";


function setFontSize(res) {
  const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (!clientWidth) return;
  let fontSize = clientWidth / 1920;
  return res * fontSize;
}

// var xAxisData = ["something...", "something...", "something...", "something..."]
// var gridWidth = 681;
// var fontsize = 14; //字体大小默认12px,这里设置成14可以保证label之间的间距
// var wordNum = parseInt((gridWidth / xAxisData.length) / fontsize);
// var maxLine = 0;
// for (var i = 0; i < xAxisData.length; i++) {
//     var flag = parseInt(xAxisData[i].length / wordNum) + 1;
//     if (flag > maxLine) maxLine = flag;
// }
// //改变chart容器高度,340为dom的height减去grid的高度和top:
// //此句放在echarts.init(dom)之前:
// document.getElementById("rangelandChart").style.height += (340 + max * 12) + "px";

export default {
  components: {
    leftTop,
    leftBottom,
    rightBottom,
    rightTop,
    // Chart,
    PieChart,
    shuhaiCarousel,
    chonghaiCarousel,
    duhaicaoCarousel

  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    maptype: {
      type: String,
      default: "",
    },
    temp: { type: Object, default: {} }
  },
  data() {
    return {
      w: 0,
      h: 0,
      urlprefix: CFG.LOTIP,
      areaAndType: {
        grasslandArea: "-",
        grasslandType: "-",
        rangeland: "-",
      },
      rangelandChartX: [],
      rangelandChartY: [],
      rangelandChartIndex: 4,
      rangelandChartInterval: null,
      rangelandChart: {
        // 全局调色盘。
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "5px",
          top: "30px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩"
        },
        xAxis: {
          type: "category",
          data: [
            // "高寒草原类",
            // "高寒荒漠类",
            // "高寒草甸类",
            // "低地草甸类",
            // "山地草甸类",
            // "温性典型草原类",
            // "温性荒漠类",

          ],

          axisLabel: {
            interval: 0,
            show: true,
            rotate: 20,
            textStyle: {
              color: "#fff"
            },
            align: 'center',
            margin: 20,
            fontSize: 11

            // backgroundColor: "#76cd3f",
            // width: 100,
            // formatter: '{a|{value}}',

            // rich: {
            //   a: {
            //     color: 'red',
            //     // lineHeight: 10
            //   },
            // }

            // formatter: function (value, index) {
            //   if (index >= 2) {
            //     return ''; // 超过12条数据的标签不显示
            //   } else {
            //     return value;
            //   }
            // }

            // interval: 0,
            // formatter: function (value) {
            //   return value.split("").join("\n");
            // },


            // interval: 0,
            // formatter: function (value) {
            //     var ret = ""; //拼接加\n返回的类目项  
            //     var maxLength = 5; //每项显示文字个数  
            //     var valLength = value.length; //X轴类目项的文字个数  
            //     var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数  
            //     if (rowN > 1) //如果类目项的文字大于5,  
            //     {
            //         for (var i = 0; i < rowN; i++) {
            //             var temp = ""; //每次截取的字符串  
            //             var start = i * maxLength; //开始截取的位置  
            //             var end = start + maxLength; //结束截取的位置  
            //             //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧  
            //             temp = value.substring(start, end) + "\n";
            //             ret += temp; //凭借最终的字符串  
            //         }
            //         return ret;
            //     } else {
            //         return value;
            //     }
            // }



          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100,
          backgroundColor: "rgba(19,227,227,0.3)"
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },

          axisLine: {
            show: true,
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },
          axisTick: {
            show: false // 是否显示刻度线
          },
          axisLabel: {
            show: false // 是否显示刻度标签
          },
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 800
          },
        },
        series: {
          data: [], //this.dataSource.ydata[0].data,
          type: "bar",
          barWidth: "50%",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            //  color: "#0099FF",

            normal: {
              // 随机显示
              // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

              // 定制显示（按顺序）
              color: function (params) {
                var colorList = [
                  "rgb(0,133,168)",
                  "rgb(158,188,216)",
                  "rgb(190,255,231)",
                  "rgb(77,230,0)",
                  "rgb(233,255,190)",
                  "rgb(103,119,206)",
                  "rgb(122,182,245)"
                ];
                let colorItem = colorList[params.dataIndex];
                return colorItem;
              },
              label: {
                show: true,
                position: 'top',
                // formatter: '{b}\n{c}',
                color: "#ffffff",
                fontSize: 11,
              }

            }
          }
        }
      },
      typeChart: {
        // 全局调色盘。
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "20px",
          top: "30px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩"
        },
        xAxis: {
          type: "category",
          data: [
            // "高寒草原类",
            // "高寒荒漠类",
            // "高寒草甸类",
            // "低地草甸类",
            // "山地草甸类",
            // "温性典型草原类",
            // "温性荒漠类",

          ],
          axisLabel: {
            show: true,
            rotate: 0,
            textStyle: {
              color: "#fff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100,
          backgroundColor: "rgba(19,227,227,0.3)"
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },

          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        series: {
          data: [], //this.dataSource.ydata[0].data,
          type: "bar",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            //  color: "#0099FF",

            normal: {
              // 随机显示
              // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

              // 定制显示（按顺序）
              color: function (params) {
                var colorList = [
                  "rgb(0,133,168)",
                  "rgb(158,188,216)",
                  "rgb(190,255,231)",
                  "rgb(77,230,0)",
                  "rgb(233,255,190)",
                  "rgb(103,119,206)",
                  "rgb(122,182,245)"
                ];
                let colorItem = colorList[params.dataIndex];
                return colorItem;
              }
            }
          }
        }
      },
      grasslandClassChartX: [],
      grasslandClassChartY: [],
      grasslandClassChartIndex: 5,
      grasslandClassChartInterval: null,
      grasslandClassChart: {
        // title: {
        //   text: '草原级',
        //   left: "10",
        //   top: "0",
        //   textStyle: {
        //     color: '#fff',
        //     fontSize:18
        //   }
        // },
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "15px",
          top: "35px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩"
        },
        xAxis: {
          type: "category",
          data: [
            // "高寒草原类",
            // "高寒荒漠类",
            // "高寒草甸类",
            // "低地草甸类",
            // "山地草甸类",
            // "温性典型草原类",
            // "温性荒漠类",

          ],
          axisLabel: {
            show: true,
            interval: 0,
            rotate: 20,
            textStyle: {
              color: "#fff"
            },
            align: 'center',
            margin: 20,
            fontSize: 11
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },

        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100,
          backgroundColor: "rgba(19,227,227,0.3)"
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },

          axisLine: {
            show: true,
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },
          axisTick: {
            show: false // 是否显示刻度线
          },
          axisLabel: {
            show: false // 是否显示刻度标签
          },
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 800
          },
        },
        series: {
          data: [], //this.dataSource.ydata[0].data,
          type: "bar",
          barWidth: "50%",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            normal: {
              // 随机显示
              // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
              // 定制显示（按顺序）
              color: function (params) {
                var colorList = [
                  "#38A800",
                  "#6FC400",
                  "#B0E000",
                  "#FFFF00",
                  "#FFAA00",
                  "#FF5500",
                  "rgb(103,119,206)",
                  "rgb(122,182,245)"
                ];


                let colorItem = colorList[params.dataIndex];
                return colorItem;
              },
              fontSize: 11
            }
          }
        }
      },
      degradationChart: {
        legend: {
          // top: "10px",
          bottom: 20,
          type: "scroll",
          textStyle: {
            color: "#fbfffd"
          },
          pageIconColor: "#00FFFF",
          pageTextStyle: {
            color: "#00FFFF"
          },
          icon: 'circle',
          itemWidth: 20,
          padding: [5, 0]
        },
        grid: {
          left: "30px",
          right: "25px",
          bottom: "110px",
          top: "10px",
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}万亩<br/>占比： {d}%"
        },
        series: [
          {
            name: "草原退化",
            type: "pie",
            radius: [0, "45%"],
            center: ["50%", "40%"],

            itemStyle: {
              color: "#c23531",
              shadowBlur: 200,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            label: {

              // position: 'inside' ,
              rotate: 'tangential',
              width: "100px",
              fontSize: 10,
              // lineHeight:15,
              edgeDistance: "55%",
              normal: {
                // formatter: "{c|{c}万亩}\n {d|{d}%}",
                formatter: "{c|{c}}\n {d|{d}%}",
                rich: {
                  c: {
                    color: "#fff"
                  },
                  d: {
                    padding: [0, 0, 5, 0],
                    color: "#00ffe4"
                  }
                },
                // margin:5
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 1
              }
            },
            data: [],
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = {
                    "无退化": "#A3FF73",
                    "轻度退化": "#FFEBAF",
                    "中度退化": "#F5CA7A",
                    "重度退化": "#CDAA66",
                  };
                  let color = colorList[params.name] ? colorList[params.name] : "#a3ff73"
                  return color;
                }
              }
            }
          }
        ]
      },
      vegetationCoverageChartX: [],
      vegetationCoverageChartY: [],
      vegetationCoverageChartIndex: 5,
      vegetationCoverageChartInterval: null,
      vegetationCoverageChart: {
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "15px",
          top: "45px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}%<br/>"
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            interval: 0,
            show: true,
            rotate: 20,
            textStyle: {
              color: "#fff"
            },
            align: 'center',
            margin: 20,
            fontSize: 11
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },


        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100
        },

        yAxis: {
          name: "%",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",
            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },
          axisTick: {
            show: false // 是否显示刻度线
          },
          axisLabel: {
            show: false // 是否显示刻度标签
          },
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 800
          },
        },
        series: {
          data: [0.10,
            200.91,
            385.42,
            139.07,
            27.83,
            3.61
          ],
          type: "bar",
          barWidth: "50%",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = [
                  "#82FDF3",
                  "#69A3F7",
                  "#3874FC",
                  "#3450FB",
                  "#755EFB",
                  "#B657FC",
                  "#BC4FFB", "#8183E0", "#2691CF", "#4FC7EA", "#9EAAD7", "#BEE8FF", "#00C5FF", "#00A9E6", "#9EBBD7", "#BED2FF", "#73B2FF", "#73DFFF", "#7A8EF5", "#6677CD", "#E8BEFF", "#FFBEE8"
                ];
                return colorList[params.dataIndex];
              },
              fontSize: 11
            }
          }
        }
      },

      cdata: {
        category: [
          "高寒草甸类",
          "高寒草原类",
          "高寒荒漠类",
          "温性典型草原类",
          "温性荒漠类",
          "低地草甸类",
          "山地草甸类",
        ],
        lineData: [0, 0, 0, 78162.58, 0, 21563.16, 0],
        title: "草原类",
        yAxisUnit: "万亩",
        rateData: [],
      },

      // rangelandChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原类",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },
      // typeChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原型",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },
      grasslandGradeChart: {
        category: [],
        lineData: [],
        title: "草原等级",
        yAxisUnit: "万亩",
        rateData: [],
      },

      // grasslandClassChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原级",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },
      // degradationChart: {
      //   xData: [],
      //   seriesData: [],
      // },
      degradationArea: 0,
      // vegetationCoverageChart: {
      //   category: [],
      //   lineData: [],
      //   title: "",
      //   yAxisUnit: "%",
      //   rateData: [],
      // },
      avgCoverage: 0,
      mapImages: [],
      pestData: [],
      conf: null,

      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [
        {
          name: "高原鼢鼠",
          url:
            "/large-screen/pest/gyfs.png",
        },
        {
          name: "高原属兔",
          url:
            "/large-screen/pest/gyst.png",
        },
        {
          name: "青海田鼠",
          url:
            "/large-screen/pest/qhts.png",
        },
        {
          name: "青海田鼠",
          url:
            "/large-screen/pest/qhts.png",
        },

      ],
      fileList4: [
        {
          name: "草原毛虫",
          url:
            "/large-screen/pest/cymc.png",
        },


      ],
      fileList5: [
        {
          name: "草原毛茛",
          url:
            "/large-screen/pest/cymg.png",
        },
        {
          name: "黄花棘豆",
          url:
            "/large-screen/pest/hhjd.jpeg",
        },
        {
          name: "黄帚橐吾",
          url:
            "/large-screen/pest/hztw.jpeg",
        },
        {
          name: "急弯棘豆",
          url:
            "/large-screen/pest/jwjd.jpeg",
        },
        {
          name: "金莲花",
          url:
            "/large-screen/pest/jlh.jpeg",
        },

      ],
      pestText:""

    };
  },
  watch: {},
  async mounted() {
    // setInterval(() => {
    //   this.getH()
    //   this.getW()
    // }, 5000);
    console.log(this.$route.query);
    console.log(this.$route.params.systemSid);

    console.log(this.conf, "conf=================");
    console.log(this.temp, "conf=================");

    // setTimeout(() => {
    //   console.log(this.conf,"conf=================")
    //           }, 5000);

    let data = await api.getConfig(this.$route.params.systemSid);
    console.log(data, "mmmmmmmmmmmm");
    if (data.resp_code == "10000") {
      this.conf = data.data;
    }

    this.getAreaAndType();
    this.getRangelandChart();
    this.getGrasslandClassChart();
    this.getDegradationChart();
    this.getVegetationCoverageChart();

    if (this.$route.query) {
      if (this.$route.query["pestIds"]) {
        this.getPestData(this.$route.query["pestIds"].join(","));
      } else {
        if (this.conf && this.conf["pestIds"]) {
          this.getPestData(this.conf["pestIds"]);
        } else {
          this.pestData = [];
        }
      }
      if (this.$route.query["homeMapImage"]) {
        this.mapImages = JSON.parse(this.$route.query["homeMapImage"]);
      } else {
        if (this.conf && this.conf["homeMapImage"]) {
          this.mapImages = JSON.parse(this.conf["homeMapImage"]);
        } else {
          this.mapImages = [];
        }
      }
    } else {
      if (this.conf) {
        if (this.conf["pestIds"]) {
          this.getPestData(this.conf["pestIds"]);
        } else {
          this.pestData = [];
        }
        if (this.conf["homeMapImage"]) {
          this.mapImages = JSON.parse(this.conf["homeMapImage"]);
        } else {
          this.mapImages = [];
        }
      }
    }

    console.log(this.mapImages, "==============")
  },
  methods: {
    getW() {
      this.w = document.getElementsByClassName('imageBox5')[0].clientWidth
    },

    getH() {
      this.h = document.getElementsByClassName('imageBox5')[0].clientHeight
    },
    changeActiveComponents(val) {
      //修改父组件传来的值
      this.$emit("changeActiveComponents", val);
    },

    getPestData(ids) {
      api.getPestData(ids).then((res) => {
        if (res.resp_code == "10000") {
          let obj = res.data
          this.fileList = obj['鼠害']
          this.fileList1 = obj['虫害']
          this.fileList2 = obj['毒害草']
          this.fileList3 = obj['病害']

          let arr=[]
          if(obj['鼠害'] && obj['鼠害'].length>0){
            arr.push("害鼠 "+obj['鼠害'].length+" 种")
          }
          if(obj['虫害'] && obj['虫害'].length>0){
            arr.push("虫害 "+obj['虫害'].length+" 种")
          }
          if(obj['毒害草'] && obj['毒害草'].length>0){
            arr.push("毒害草 "+obj['毒害草'].length+" 种")
          }
          if(obj['病害'] && obj['病害'].length>0){
            arr.push("病害 "+obj['病害'].length+" 种")
          }

          let str=arr.join("、")
          this.pestText= arr.length>0? ("常见有"+str):""

        }
      });



    },

    getAreaAndType() {
      api.getAreaAndType(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.areaAndType.grasslandArea = res.data.grasslandArea
            ? res.data.grasslandArea
            : "-";
          this.areaAndType.grasslandType = res.data.grasslandType
            ? res.data.grasslandType
            : "-";
          this.areaAndType.rangeland = res.data.rangeland ? res.data.rangeland : "-";
        }
      });
    },
    getRangelandChart() {
      api.getRangelandChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          // if (res.data.x.length > 5) {
            // this.rangelandChartX = res.data.x;
            // this.rangelandChartY = res.data.y;
            // this.rangelandChart.xAxis.data = res.data.x.slice(0, 5);
            // this.rangelandChart.series.data = res.data.y.slice(0, 5);
            // this.rangelandChartInterval = setInterval(this.chageRangelandChart, 3500)

          // } else {
            this.rangelandChart.xAxis.data = res.data.x;
            this.rangelandChart.series.data = res.data.y;
          // }

        }
      });
    },
    chageRangelandChart() {
      console.log("chageRangelandChart")
      this.rangelandChartIndex = this.rangelandChartIndex + 1 > this.rangelandChartX.length - 1 ? 0 : this.rangelandChartIndex + 1
      this.rangelandChart.xAxis.data.shift();
      this.rangelandChart.series.data.shift();
      this.rangelandChart.xAxis.data.push(this.rangelandChartX[this.rangelandChartIndex]);
      this.rangelandChart.series.data.push(this.rangelandChartY[this.rangelandChartIndex]);
    },
    getTypeChart() {
      api.getTypeChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.typeChart.xAxis.data = res.data.x;
          this.typeChart.series.data = res.data.y;
        }
      });
    },
    getGrasslandGradeChart() {
      api.getGrasslandGradeChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.grasslandGradeChart.category = res.data.x;
          this.grasslandGradeChart.lineData = res.data.y;
        }
      });
    },
    getGrasslandClassChart() {
      api.getGrasslandClassChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {

          //   if (res.data.x.length > 6) {
          //     this.grasslandClassChartX = res.data.x;
          //     this.grasslandClassChartY = res.data.y;
          //     this.grasslandClassChart.xAxis.data = res.data.x.slice(0, 6);
          //     this.grasslandClassChart.series.data = res.data.y.slice(0, 6);
          //     this.grasslandClassChartInterval = setInterval(this.chageGrasslandClassChart, 3500)

          //   } else {
          this.grasslandClassChart.xAxis.data = res.data.x;
          this.grasslandClassChart.series.data = res.data.y;
          // }
        }
      });
    },
    chageGrasslandClassChart() {
      console.log("chageGrasslandClassChart")
      this.grasslandClassChartIndex = this.grasslandClassChartIndex + 1 > this.grasslandClassChartX.length - 1 ? 0 : this.grasslandClassChartIndex + 1
      this.grasslandClassChart.xAxis.data.shift();
      this.grasslandClassChart.series.data.shift();
      this.grasslandClassChart.xAxis.data.push(this.grasslandClassChartX[this.grasslandClassChartIndex]);
      this.grasslandClassChart.series.data.push(this.grasslandClassChartY[this.grasslandClassChartIndex]);
    },

    // getDegradationChart() {
    //   api.getDegradationChart(this.$route.params.systemSid).then((res) => {
    //     if (res.resp_code == "10000") {
    //       console.log(res.data,"pppppppppppppppp")
    //       this.grasslandClassChart.category = res.data.x;
    //       this.grasslandClassChart.lineData = res.data.y;
    //       this.degradationArea=res.data.area.sum
    //     }
    //   });
    // },

    getDegradationChart() {
      api.getDegradationChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          // this.degradationChart.xData = res.data.legend;

          let obj = [
            { name: "无退化", value: 0 },
            { name: "轻度退化", value: 0 },
            { name: "中度退化", value: 0 },
            { name: "重度退化", value: 0 }
          ]
          if (res.data.data) {
            res.data.data.forEach((item) => {
              if (item.name == "无退化") {
                obj[0].value = item.value.toFixed(2)
              } else if (item.name == "轻度退化") {
                obj[1].value = item.value.toFixed(2)
              } else if (item.name == "中度退化") {
                obj[2].value = item.value.toFixed(2)
              } else if (item.name == "重度退化") {
                obj[3].value = item.value.toFixed(2)
              }
            });
          }
          this.degradationChart.series[0].data = obj;

          this.degradationArea = res.data.area ? res.data.area.sum.toFixed(2) : "-";
        }
      });
    },

    getVegetationCoverageChart() {
      api.getVegetationCoverageChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          if (res.data.x.length > 6) {
            this.vegetationCoverageChartX = res.data.x;
            this.vegetationCoverageChartY = res.data.y;
            this.vegetationCoverageChart.xAxis.data = res.data.x.slice(0, 6);
            this.vegetationCoverageChart.series.data = res.data.y.slice(0, 6);
            this.vegetationCoverageChartInterval = setInterval(this.vegetationCoverageChartChart, 3500)

          } else {
            this.vegetationCoverageChart.xAxis.data = res.data.x;
            this.vegetationCoverageChart.series.data = res.data.y;
          }



          this.avgCoverage = res.data.avgCoverage
            ? res.data.avgCoverage.avgCoverage.toFixed(2)
            : "-";
        }
      });
    },
    vegetationCoverageChartChart() {
      console.log("vegetationCoverageChartChart")
      this.vegetationCoverageChartIndex = this.vegetationCoverageChartIndex + 1 > this.vegetationCoverageChartX.length - 1 ? 0 : this.vegetationCoverageChartIndex + 1
      this.vegetationCoverageChart.xAxis.data.shift();
      this.vegetationCoverageChart.series.data.shift();
      this.vegetationCoverageChart.xAxis.data.push(this.vegetationCoverageChartX[this.vegetationCoverageChartIndex]);
      this.vegetationCoverageChart.series.data.push(this.vegetationCoverageChartY[this.vegetationCoverageChartIndex]);
    },
  },
  beforeDestroy() {
    console.log("销毁")
    if (this.rangelandChartInterval) {
      clearInterval(this.rangelandChartInterval);
    }
    if (this.grasslandClassChartInterval) {
      clearInterval(this.grasslandClassChartInterval);
    }
    if (this.vegetationCoverageChartInterval) {
      clearInterval(this.vegetationCoverageChartInterval);
    }

  }
};
</script>

<style lang="scss" scoped>
// .map_image /deep/ .el-carousel__item{
//   position: relative;
// }

.block_click {
  pointer-events: auto;
}

.block_no_click {
  pointer-events: none;
}

.pest_image /deep/ .el-carousel__arrow {
  top: 40%;
}

.image_box div:nth-last-child(1) {
  margin-right: 0% !important;
}

.image_box1 div:nth-last-child(1) {
  margin-right: 0% !important;
}

.image_box1 div:nth-child(1) {
  margin-left: 3% !important;
}

.image_box div:nth-child(1) {
  margin-left: 3% !important;
}

.pest_image /deep/ .el-carousel__button {
  width: 5px;
  height: 5px;
}

.pest_image /deep/ .el-carousel__indicators--horizontal {
  bottom: 15%;
}

.pest_image /deep/ .el-carousel__container {
  height: 100%;
}

.map_image /deep/ .el-carousel__arrow {
  font-weight: 800;
  font-size: 2vw;
  line-height: 2vw;
}

.map_image /deep/ .el-carousel__container {
  height: 100%;
}







.image_title {
  font-style: oblique;
  text-align: center;
  color: #fff;
  font-size: 1.5vw;
  height: 10%;
  // line-height: 40px;
  font-weight: 500;
  text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.title_icon {
  transform: rotate(90deg);
  font-weight: 700;
  color: #00ffff;
}

.resource-title {
  color: #fff;
  font-size: 1.5vw;
  height: 40px;
  line-height: 40px;
  margin-top: -10px;
  font-weight: 500;
  cursor: pointer;
  // text-shadow: 0 0 10px #0fd4db, 0 0 10px #00FF00, 0 0 10px #0000FF;
  text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
  // outline: 1px solid #000;
  // text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);
}

.image_base {
  width: 100%;
  height: 100%;
  padding: 16px 16px 0 16px;
  background-image: url("../../../assets/large-screen-img/ditu.png");
  background-size: cover;
  background-position: center center;
}
</style>
<style>
.el-image-viewer__mask {
  opacity: 1 !important;
  background: #fff !important;
}
</style>
